<!----复杂筛选框组件----->
<template>
  <div class="complexSelect">
    <el-popover placement="right" v-model="visible" trigger="focus">
      <el-table
        ref="table"
        :empty-text="empty"
        :data="data"
        @current-change="selectRow"
        :height="height"
        v-if="tableType"
      >
        <template v-for="(i,key) in tbHead">
          <el-table-column  :key="key" :min-width="i.Width" :prop="i.Value" show-overflow-tooltip>
            <template slot="header" slot-scope="/* eslint-disable vue/no-unused-vars */ scope">
              <span v-if="!i.Custom">{{i.Name}}</span>
              <el-input v-else v-model="search" @input="onSearch(i.Value)" :placeholder="i.Name" />
            </template>
          </el-table-column>
        </template>
      </el-table>
      <page-module
        v-if="pageType"
        :listTotal="total"
        :page-size="pageParams.pageSize"
        @currentPage="currentPage"
        :pageIndex="pageParams.pageIndex"
      />
      <template slot="reference">
        <el-input
          v-model="text"
          :placeholder="value?value:placeholder"
          @keyup.enter.native="enterFun"
          @clear="clear"
          :clearable="clearable"
          @size-change="onPageSizeChange"
        ></el-input>
      </template>
    </el-popover>
  </div>
</template>
<script>
import pageModule from "@/components/common/pageModule";
export default {
  components: {
    pageModule,
  },
  props: {
    pageType: {
      type: Boolean,
      default: false,
    },
    pageIndex: {
      type: Number,
      default: 1,
    },
    listTotal: {
      type: Number,
      default: undefined,
    },
    value: {},
    //表格最大高度
    height: {
      type: String,
      default: "300",
    },
    //表头
    tbHead: {
      type: Array,
      default: () => [],
    },
    //表数据
    tbData: {
      type: Array,
      default: () => [],
    },
    //用于搜索的字段
    keyStr: {
      type: String,
      default: "Name",
    },
    //查询不到的数据是否可以创建
    create: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    empty: {
      type: String,
      default: "暂无数据",
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    pageSize: {
      type: Number,
      default: undefined,
    },
  },
  data() {
    return {
      tableType: Math.random(),
      total: 0,
      data: [],
      text: "", //输入框的值
      time: null, //搜索延迟
      visible: false, //是否显示
      search: "", //搜索关键字
      pageParams: {
        pageSize: this.pageSize || this.$store.state.sys.pageSize, //分页大小
        pageIndex: this.pageIndex,
      },
    };
  },
  mounted() {
    this.text = this.value;
  },
  computed: {},
  watch: {
    pageIndex() {
      this.pageParams.pageIndex = this.pageIndex;
    },
    listTotal() {
      this.total = this.listTotal;
    },
    tbData() {
      this.tableType = Math.random();
    },
    visible(val) {
      if (val) this.data = this.tbData;
      else this.search = "";
      if (!this.create) {
        // if (!val)
      } else {
        this.$emit("input", this.text);
        if (!val && !this.data.some((x) => x[this.keyStr] == this.text)) {
          this.$emit("create");
        }
      }
    },
    value(val) {
      //
      this.text = this.value;
    },
    tbData(val) {
      this.data = this.tbData;
    },
    text(val) {
      if (this.pageType) {
        this.$emit("inputText", this.text);
      } else if (this.visible) {
        this.data = this.tbData;
        this.data = this.data.filter(
          (x) => x[this.keyStr].indexOf(this.text) != -1
        );
        
      }
    },
  },
  methods: {
    currentPage(val) {
      this.$emit("currentPage", val);
    },
    onPageSizeChange() {},
    enterFun() {
      if (this.data.length > 0) {
        this.$emit("input", this.data[0][this.keyStr]);
        this.$emit("select", this.data[0]);
        this.visible = false;
      }
    },
    onSearch(key) {
      console('触发 onSearch', key)
      if (this.search) {
        this.data = this.data.filter((x) => x[key].indexOf(this.search) != -1);
      } else {
        this.data = this.tbData;
      }

    },
    selectRow(val) {
      if (val) {           
        this.text = this.value;  
        this.$emit("input", val[this.keyStr]);
        this.$emit("select", val);
        this.visible = false;
      }
    },
    clear() {
      this.$emit("input", null);
      this.$emit("clear");
      this.$refs.table.setCurrentRow(null);
    },
  },
};
</script>
<style lang="scss">
</style>